module.exports = __webpack_public_path__ + "img/visuels-campagne-full-gafam-22_slideshow-immo.985fd0f9.png";